var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from "react";
import { Button, RightDiv, Separator, Spinner } from "@atlassiansox/microscopekit";
import { ButtonGroup } from "@atlaskit/button";
import { PremiseDetailView } from "../PremiseDetailView";
import { PremiseEditor } from "./PremiseEditor";
import { useSendScreenEvent } from "../../analytics";
import { IsPremiseDisabled, PremiseDisabledSectionMessage } from "../../utils/premiseDisabled";
import styled from "styled-components";
export var PremiseFormFc = function (_a) {
    var premise = _a.premise, isLoading = _a.isLoading, onSkip = _a.onSkip, premiseBeingEdited = _a.premiseBeingEdited, setPremiseBeingEdited = _a.setPremiseBeingEdited, startEditing = _a.startEditing, stopEditing = _a.stopEditing, submit = _a.submit, deletePremise = _a.deletePremise, environment = _a.environment;
    useSendScreenEvent("createWargamePlanPremiseSetupStep");
    if (isLoading) {
        return React.createElement(Spinner, null, "Loading Template Details");
    }
    if (premiseBeingEdited) {
        return (React.createElement(PremiseEditor, { premise: premiseBeingEdited, setPremise: setPremiseBeingEdited, onCancel: stopEditing, onSubmit: submit }));
    }
    if (premise) {
        return (React.createElement(PremiseDetailView, { premise: premise, editForm: startEditing, onDelete: deletePremise }));
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(Separator, null),
        React.createElement("h4", null, "Configure Premise setup"),
        IsPremiseDisabled(environment) ? (React.createElement(SectionMessageDiv, null,
            React.createElement(PremiseDisabledSectionMessage, { environment: environment }))) : (React.createElement(React.Fragment, null,
            React.createElement("p", null,
                "You can configure the premise setup prior to defining actual chaos experiments. ",
                React.createElement("br", null),
                "This is ",
                React.createElement("b", null, "optional"),
                ". Currently, we support perhammer load generations part of the premise setup. ",
                React.createElement("br", null),
                "Refer",
                " ",
                React.createElement("a", { href: "http://go/brahmos-premise", target: "_blank", rel: "noopener noreferrer" }, "http://go/brahmos-premise"),
                " ",
                "for more details."))),
        React.createElement(Separator, null),
        React.createElement(RightDiv, null,
            React.createElement(ButtonGroup, null,
                React.createElement(Button, { onClick: onSkip }, "Skip"),
                React.createElement(Button, { appearance: "primary", onClick: startEditing, disabled: IsPremiseDisabled(environment) }, "Setup Premise")))));
};
var SectionMessageDiv = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-top: 10px;\n  margin-bottom: 10px;\n"], ["\n  margin-top: 10px;\n  margin-bottom: 10px;\n"])));
var templateObject_1;
